import { Observable } from 'rxjs';
import { fetchModelLabelListAPI } from '../../api/fetch-functions/label';
import { ILabelFromApiType } from '../../types/record/label';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  oneIdListSetReducerGenerator,
  oneIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/one-id-list';

const fetchSignal$ = fetchIdStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchLabelListOf = (modelId: number) => f(modelId);

/**
 * @description
 * `fetchLabelListOf(modelId)` を実行すると
 * `labelListSet$` の該当idの要素を re-fetch する．
 */
const updateLabelList$ = updateStreamGenerator(
  fetchSignal$,
  fetchModelLabelListAPI
);

const labelListSetReducer = oneIdListSetReducerGenerator<ILabelFromApiType>();

/**
 * @description
 * すべての labelList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const labelListSet$ = oneIdListSetStreamGenerator(
  updateLabelList$,
  labelListSetReducer
);

const g = listOfIdFnGenerator(labelListSet$);
export const labelListOf = (
  modelId: number
): Observable<ListWithPromiseState<ILabelFromApiType>> => {
  fetchLabelListOf(modelId);
  return g(modelId);
};
